export class RecorrenciaCancelDTO {

  recorrenciaId: string;
  usuarioId: string;
  usuarioNome: string;

}
